import React, { FC } from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import PlanerIcon from 'assets/images/relifCompanies/planer-logo.webp';
import SikerIcon from 'assets/images/relifCompanies/siker-logo.webp';
import ZellerIcon from 'assets/images/relifCompanies/zeller-logo.webp';
import useIsMobile from 'hooks/useIsMobile';

const BlueSeparator = () => (
  <svg
    width="100%"
    preserveAspectRatio="none"
    height="2"
    viewBox="0 0 180 2"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 1.00003L180 1.00005" stroke="#47BCD8" strokeWidth="2" />
  </svg>
);

const FooterContacts = (title: string, content: string) => (
  <Box pb={{ xs: 1.5, lg: 0 }} sx={{ textAlign: 'center' }}>
    <Box width="min-content" sx={{ margin: '0 auto' }}>
      <Typography
        fontFamily="Roboto"
        fontSize={{ lg: '15px', xs: '16px' }}
        lineHeight="24px"
        fontWeight="600"
        textTransform="uppercase"
        color="white"
      >
        {title}
      </Typography>
      <BlueSeparator />
    </Box>
    <Typography
      fontFamily="Jost"
      fontSize={{ lg: '15px', xs: '14px' }}
      lineHeight="24px"
      fontWeight="regular"
      color="white"
    >
      {content}
    </Typography>
  </Box>
);

const Footer: FC = () => {
  const { isMobile } = useIsMobile();

  return (
    <Box
      sx={{
        backgroundColor: '#15183A',
        width: '100%',
        position: 'relative',
        overflow: 'hidden',
        py: { xs: 4, md: 2 },
        pb: { xs: '120px', md: 2 },
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          ...(isMobile
            ? {
                left: 0,
                right: 0,
                bottom: 0,
                height: '100px',
                borderTopLeftRadius: '100%',
                borderTopRightRadius: '100%',
              }
            : {
                right: 0,
                top: 0,
                bottom: 0,
                width: '25%',
                borderTopLeftRadius: '50%',
                borderBottomLeftRadius: '50%',
              }),
          bgcolor: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: isMobile ? 'center' : '',
            gap: 3,
            width: isMobile ? '60%' : '80%',
            position: 'relative',
            pl: isMobile ? 0 : 2,
            mb: isMobile ? 2 : 0,
          }}
        >
          <Box component="img" src={PlanerIcon} alt="Planer" height={isMobile ? '35px' : '50px'} />
          <Box component="img" src={ZellerIcon} alt="Zeller" height={isMobile ? '25px' : '35px'} />
          <Box component="img" src={SikerIcon} alt="Siker" height={isMobile ? '25px' : '35px'} />
        </Box>
      </Box>
      <Box
        sx={{
          maxWidth: '1200px',
          margin: '0 auto',
          px: { xs: 2, md: 4 },
          py: 1,
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: 'center',
          alignItems: 'center',
          position: 'relative',
          zIndex: 2,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            alignItems: 'center',
            gap: { xs: 2, md: 6 },
            width: { md: '65%' },
          }}
        >
          <Typography
            fontFamily="Roboto"
            fontSize={{ md: '22px', xs: '18px' }}
            lineHeight="24px"
            fontWeight="600"
            color="white"
            textAlign="center"
          >
            CONTACTO
          </Typography>

          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              gap: { xs: 2, md: 4 },
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
            }}
          >
            {FooterContacts('DIRECCIÓN', 'San Patricio 4266, Santiago, Chile')}
            {FooterContacts('TELÉFONO', '+56 9 92268245')}
            {FooterContacts('CORREO', 'contacto@relif.cl')}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
